import { useMutation } from "@/compat/reactQuery";
import incidentService from "../../services/incidentService";

const useUpdateIncident = () => useMutation(incidentService.updateIncident);

export default useUpdateIncident;
